module.exports = __webpack_public_path__ + "img/total-rock.1dbb75ff.png";